import { NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { environment } from '../../../../environments/environment.prod'
import { MiddleService } from './middle.service'
@Component({
    selector: 'gd-dropdownhover',
    template: `
    <div [formGroup]="form">
      <kendo-dropdownlist
        [formControlName]="field.name"
        [id]="field.name"
        *ngIf="field.name === 'StatusTypeID'"
        (selectionChange)="selectionChanger($event)"
        [style]="calculateStyle()"
        [data]="field.options"
        [valueField]="'key'"
        [textField]="'label'"
        [valuePrimitive]="true"
      >
      </kendo-dropdownlist>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
            KENDO_DROPDOWNS,
    ]
})
export class DropDownHoverComponent {
  isDisabled = true; 
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Input() width = '350px'
  @Input() height = '20px'
  finalWidth: number
  finalHeight: number
  public validinfo: boolean
  public rowStatus = false
  public warningStatus = false
  public warnmsg = environment.warningSurrender
  public showViewhistorybtn: boolean
  public showAlertHistoryPopup = false

  constructor(private metamsg: MiddleService, private route: ActivatedRoute) {
    this.validinfo = false
    this.rowStatus = false
    this.onloadchanges()
  }
  public openmodel() {
    this.metamsg.changeBool(true)
  }
  public toggleAlertHistory() {
    this.showAlertHistoryPopup = !this.showAlertHistoryPopup
  }
  selectionChanger(event: { key: string }) {

    if (event.key !== 'CUSTOM') {
      if (this.form.get('AlertRepTextselect').value === 'CUSTOM') {
        localStorage.setItem(
          'UnsavedAlertText',
          this.form.get('AlertRepText').value,
        )
      }
    }

    if (event.key === 'NIGO') {
      this.form.get('AlertRepText').setValue('')
      this.form.get('AlertRepText').setValue(environment.alertreptxt)
      return
    }
    if (event.key === 'PENDING ALERT') {
      this.form.get('AlertRepText').setValue('')
      this.form.get('AlertRepText').setValue(environment.alertpendingtxt)
      return
    }
    if (event.key === 'CUSTOM') {
      this.form
        .get('AlertRepText')
        .setValue(localStorage.getItem('UnsavedAlertText'))
      return
    }
    if (event.key === 'Missing') {
      this.validinfo = true
      return
    } else {
      this.validinfo = false
      return
    }
  }
  onloadchanges() {
    this.showViewhistorybtn = false
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe(() => {
        this.showViewhistorybtn = true
      })
    }
  }

  calculateStyle() {
    return {
      width: this.width,
      height: this.height,
    }
  }
}
